import axios from 'axios';
import Cookies from 'js-cookie';
import Message from 'rc-message';
import { HostEnv, getHostEnvByLocation } from '../utils';
import { ApiBizError } from './ApiBizError';
import { removeArgtStorage } from '@/pages/Home/AgrtModal/argt';
// import qs from 'qs';
// import { message as Message } from 'antd';

/**
 * 后端接口的baseUrl
 */
// const API_BASE_URL = '/api';

/**
 * 后端POST请求要求携带从cookie读取的参数，不同环境参数名不同
 */
const hostEnvAuthParamKeyMap = {
  [HostEnv.Staging]: 'assistant_magdev_ph',
  [HostEnv.Staging4QA]: 'assistant_magdev4qa_ph',
  [HostEnv.Preview]: 'assistant_magdevpw_ph',
  [HostEnv.Production]: 'assistant_magdev_ph',
};
const COOKIE_PARAM_KEY = hostEnvAuthParamKeyMap[getHostEnvByLocation()];
// console.log('auth param', COOKIE_PARAM_KEY);

const httpService = axios.create({
  // baseURL: API_BASE_URL,
  // timeout: 5000 // 请求超时时间
  //withCredentials: true,
});

httpService.interceptors.request.use((reqConfig) => {
  if (reqConfig.method === 'post') {
    reqConfig.params = {
      ...reqConfig.params,
      [COOKIE_PARAM_KEY]: Cookies.get(COOKIE_PARAM_KEY),
    };
  }
  return reqConfig;
});

// Add a response interceptor
httpService.interceptors.response.use(
  (ret) => {
    if (ret.data && ret.data.code === 0) {
      return ret.data.data || true; // 防止某些成功接口的data为null
    }

    if (ret.data && ret.data.code === 301) {
      sessionStorage.setItem('login', '0');
      return;
    }
    const code = (ret.data && ret.data.code) || ret.status;
    const message = (ret.data && ret.data.msg) || ret.statusText;

    // 错误弹窗
    // console.error(`${message}`);
    // Message.error({
    //   content: message,
    // });

    return Promise.reject(new ApiBizError(code, message));
  },
  (error) => {
    const status = error?.response?.status;

    // if (status === 401) {
    //   // 401 跳转登录
    //   const { href, protocol, host } = window.location;
    //   // 把重定向的接口地址，暂时改为node项目的login
    //   const loginUrl = `${protocol}//${host}${API_BASE_URL}/login?from=${encodeURIComponent(
    //     href,
    //   )}`;
    //   // 清除已读协议的标记
    //   removeArgtStorage();
    //   window.location.href = loginUrl;
    //   return null;
    // }

    // 对于含义明确的错误，只需要打印接口路径
    const statusMap = [403, 404];
    const url = error?.response?.config?.url;
    const msg = error?.response?.data?.message;
    if (statusMap.indexOf(status) > -1) {
      console.error(`${status}: ${url}`);
    } else {
      console.error(`${msg || error}`);
    }

    return Promise.reject(error);
  },
);

export { httpService };
